import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31fd122c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "coaching-topic-team-member-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Team", -1))
const _hoisted_3 = { class: "coaching-topic-team-member-selected-option" }
const _hoisted_4 = { class: "coaching-topic-team-member-tiles" }
const _hoisted_5 = {
  key: 0,
  class: "coaching-topic-team-member-tile"
}
const _hoisted_6 = { class: "coaching-topic-sort-modal" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopicResponsesBreakdown = _resolveComponent("TopicResponsesBreakdown")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TeamMemberTileWeb = _resolveComponent("TeamMemberTileWeb")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.topicData)
      ? (_openBlock(), _createBlock(_component_TopicResponsesBreakdown, {
          key: 0,
          class: "topic-responses-breakdown",
          "question-type": _ctx.insightsCoaching.question_type,
          data: _ctx.topicData,
          "total-topic-response-count": _ctx.totalTopicResponseCount
        }, null, 8, ["question-type", "data", "total-topic-response-count"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "coaching-topic-team-member-sort",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTeamSortModal = true))
      }, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedSortOption), 1),
        _createVNode(_component_FontAwesomeIcon, {
          class: "coaching-topic-team-member-chevron",
          icon: _ctx.faChevronDown
        }, null, 8, ["icon"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamMembers, (teamMemberData, name) => {
          return (_openBlock(), _createBlock(_component_TeamMemberTileWeb, {
            key: name,
            name: name,
            data: teamMemberData,
            topic: _ctx.topic,
            badge: _ctx.topicData.badge,
            class: "coaching-topic-team-member-tile"
          }, null, 8, ["name", "data", "topic", "badge"]))
        }), 128)),
        (Object.keys(_ctx.teamMembers).length % 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_Modal, {
        top: 25,
        show: _ctx.showTeamSortModal,
        "allow-click-out": "",
        "allow-escape": "",
        "has-close": false,
        title: "View Results By:",
        size: "small",
        close: () => (_ctx.showTeamSortModal = false),
        "visible-if-overflow": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (sortOption, idx) => {
            return (_openBlock(), _createElementBlock("div", { key: idx }, [
              _createElementVNode("div", {
                class: "coaching-topic-sort-option",
                onClick: ($event: any) => (_ctx.selectSortOption(sortOption))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass({
                                active: sortOption === _ctx.selectedSortOption,
                            })
                }, _toDisplayString(sortOption), 3),
                _createElementVNode("div", null, [
                  (sortOption === _ctx.selectedSortOption)
                    ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                        key: 0,
                        icon: _ctx.faCheck,
                        class: "active"
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true)
                ])
              ], 8, _hoisted_7)
            ]))
          }), 128))
        ], undefined, true),
        _: 1
      }, 8, ["show", "close"])
    ])
  ]))
}